import * as actionTypes from "../../actions";
const initialState = {
  data: [],
  loading: false
};
const adminCustomer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.STORE_ADMINCUSTOMERVEHICLES:
      return {
        data: action.data,
        loading: false
      };
    // case actionTypes.GET_VEHICLE:
    //   return Object.assign({}, state);
    default:
      return state;
  }
};
export default adminCustomer;



// WEBPACK FOOTER //
// ./src/redux/reducers/admin/index.js